const GAME_PAGE_SEGMENTS = ["play"];

const isGamePageRoute = (segments: string[]) =>
  segments.some((segment) => GAME_PAGE_SEGMENTS.includes(segment));

export default isGamePageRoute;
